var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconElementAlignLeftLine = function SvgIconElementAlignLeftLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5.251h13.5v1.5H5.25v-1.5ZM5.25 17.251h13.5v1.5H5.25v-1.5ZM6.35 10.706v1.84h5.3v-1.84h-5.3Zm-1.7-.25c0-.8.65-1.45 1.45-1.45h5.8c.801 0 1.45.65 1.45 1.45v2.34c0 .8-.649 1.45-1.45 1.45H6.1c-.8 0-1.45-.65-1.45-1.45v-2.34Z",
    fill: "current"
  })));
};
export default SvgIconElementAlignLeftLine;